import request from "@/utils/request";

export async function getTodayQueuesByPhone(phone) {
  const response = await request.get(`/dine-in/queues/phone/${phone}`);
  return response.data.data;
}

export async function createQueue(queue) {
  const response = await request.post("/dine-in/queues", queue);
  return response.data.data;
}

export async function getQueueById(id) {
  const response = await request.get(`/dine-in/queues/${id}`);
  return response.data.data;
}
